var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "paging_board" }, [
    _c(
      "a",
      {
        staticClass: "btn_page btn_prev",
        attrs: { href: "javascript:", disabled: _vm.isFirstPage },
        on: {
          click: function ($event) {
            return _vm.toPrevPage()
          },
        },
      },
      [_c("span", { staticClass: "ico_cafe ico_prev" }, [_vm._v("이전페이지")])]
    ),
    _vm._v(" "),
    _c(
      "span",
      { staticClass: "desc_paging", attrs: { id: "pagingNav" } },
      [
        _c("span", { staticClass: "sr_only" }, [_vm._v("현재페이지")]),
        _vm._v(" "),
        _vm._l(_vm.pageList, function (i) {
          return _c("span", { staticClass: "num_page" }, [
            _vm.page === i
              ? _c("em", { staticClass: "link_page" }, [_vm._v(_vm._s(i + 1))])
              : _c(
                  "a",
                  {
                    staticClass: "link_page",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function ($event) {
                        return _vm.goToPage(i)
                      },
                    },
                  },
                  [_vm._v(_vm._s(i + 1))]
                ),
          ])
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "btn_page btn_next",
        attrs: { href: "javascript:", disabled: _vm.isLastPage },
        on: {
          click: function ($event) {
            return _vm.toNextPage()
          },
        },
      },
      [_c("span", { staticClass: "ico_cafe ico_next" }, [_vm._v("다음페이지")])]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }